(function initializeVoyadoListControls(window, document) {
    'use strict';

    const FACET_SELECTOR = '[data-voyado-facet]';
    const labels = window.VOYADO_CONTEXT?.labels || {};

    function createElement(tag, className, text) {
        const element = document.createElement(tag);
        if (className) element.className = className;
        if (text !== undefined) element.textContent = text;
        return element;
    }

    function facetValues(facet) {
        if (facet.type === 'CHECKBOX') {
            return [{
                id: 'true',
                label: facet.label,
                count: facet.count,
                selected: facet.selected,
            }];
        }

        if (Array.isArray(facet.values)) return facet.values;
        if (!Array.isArray(facet.sizeTypes)) return [];

        return facet.sizeTypes.flatMap((sizeType) =>
            (sizeType.formats || []).flatMap((format) =>
                format.values || format.sizes || []
            )
        );
    }

    function cloneFilters(filters) {
        if (!filters || typeof filters !== 'object') return {};
        if (typeof structuredClone === 'function') return structuredClone(filters);
        return JSON.parse(JSON.stringify(filters));
    }

    function create(options) {
        const sort = document.getElementById('sort-by');
        const facetContainer = document.querySelector('#facets .filter-form');
        const facetForm = facetContainer?.closest('form');
        const currentFacets = document.getElementById('current-facets-ajax');
        const clearFilters = facetForm?.querySelector('.btn--secondary');
        const rangeBounds = new Map();

        function selectedFiltersFromForm() {
            const filters = {};
            if (!facetForm) return filters;

            for (const input of facetForm.querySelectorAll(FACET_SELECTOR)) {
                const id = input.dataset.voyadoFacet;
                if (!id) continue;

                if (input.type === 'checkbox') {
                    if (!input.checked) continue;
                    (filters[id] ||= []).push(input.value);
                    continue;
                }

                if (input.value === '') continue;
                if (
                    (input.dataset.rangeBound === 'min' && input.min !== '' && Number(input.value) <= Number(input.min)) ||
                    (input.dataset.rangeBound === 'max' && input.max !== '' && Number(input.value) >= Number(input.max))
                ) continue;
                filters[id] ||= {};
                filters[id][input.dataset.rangeBound] = Number(input.value);
            }

            return filters;
        }

        function createValueFacet(facet) {
            const type = facet.type === 'COLOR' ? 'color' : 'default';
            const list = createElement('ul', `filter-options-list ${type}`);
            list.style.gap = '8px';

            for (const value of facetValues(facet)) {
                const item = createElement('li', 'filter-option');
                const label = createElement('label', `filter-type-${type}`);
                const input = createElement(
                    'input',
                    type === 'color' ? 'for-swatch' : 'checkbox'
                );
                input.type = 'checkbox';
                input.name = `f.${facet.id}`;
                input.value = value.id;
                input.checked = value.selected === true;
                input.dataset.voyadoFacet = facet.id;
                label.append(input);

                if (type === 'color') {
                    const swatch = createElement('span', 'swatch');
                    const color = createElement('span', 'color');
                    color.style.setProperty('--color', value.color || value.id);
                    swatch.append(color);
                    label.append(swatch);
                }

                const count = value.count === undefined ? '' : ` (${value.count})`;
                label.append(createElement('span', '', `${value.label}${count}`));
                item.append(label);
                list.append(item);
            }

            return list;
        }

        function createRangeFacet(facet) {
            const savedBounds = rangeBounds.get(facet.id) || {};
            const apiMin = facet.min == null ? NaN : Number(facet.min);
            const apiMax = facet.max == null ? NaN : Number(facet.max);
            if (Number.isFinite(apiMin)) savedBounds.min ??= apiMin;
            if (Number.isFinite(apiMax)) savedBounds.max ??= apiMax;
            rangeBounds.set(facet.id, savedBounds);

            const rangeMin = Number.isFinite(apiMin) ? apiMin : savedBounds.min ?? 0;
            const selectedMax = Number(facet.maxSelected);
            const rangeMax = Number.isFinite(apiMax)
                ? apiMax
                : savedBounds.max ?? (Number.isFinite(selectedMax) ? selectedMax : rangeMin);
            const wrapper = createElement('div', 'voyado-range');
            const slider = createElement('div', 'price-range__slider');
            const display = createElement('div', 'price-range__display-wrapper');
            const fields = {};

            for (const bound of ['min', 'max']) {
                if (bound === 'max') {
                    display.append(
                        createElement('span', 'price-range__horizontal-divider', '-')
                    );
                }

                const inputWrapper = createElement(
                    'span',
                    'price-range__input-wrapper size--small'
                );
                const input = createElement('input', `price-range__input price-range__input-${bound}`);
                input.type = 'number';
                if (Number.isFinite(rangeMin)) input.min = String(rangeMin);
                if (Number.isFinite(rangeMax) && rangeMax > rangeMin) input.max = String(rangeMax);
                input.value = facet[`${bound}Selected`] ?? '';
                input.placeholder = String(facet[bound] ?? '');
                const boundLabel = bound === 'min'
                    ? labels.facetFrom || ''
                    : labels.facetTo || '';
                input.setAttribute('aria-label', `${facet.label}: ${boundLabel}`);
                input.dataset.voyadoFacet = facet.id;
                input.dataset.rangeBound = bound;
                inputWrapper.append(input);
                display.append(inputWrapper);
                fields[bound] = input;
            }

            wrapper.append(slider, display);

            if (window.noUiSlider && rangeMax > rangeMin) {
                window.noUiSlider.create(slider, {
                    start: [
                        Number(facet.minSelected ?? rangeMin),
                        Number(facet.maxSelected ?? rangeMax),
                    ],
                    connect: true,
                    step: Number(facet.step ?? 1),
                    range: { min: rangeMin, max: rangeMax },
                });
                slider.noUiSlider.on('update', (values) => {
                    fields.min.value = String(Math.round(Number(values[0])));
                    fields.max.value = String(Math.round(Number(values[1])));
                });
                slider.noUiSlider.on('change', () => applyFilters());
                for (const input of Object.values(fields)) {
                    input.addEventListener('change', () => {
                        const minValue = fields.min.value === '' ? rangeMin : Number(fields.min.value);
                        const maxValue = fields.max.value === '' ? rangeMax : Number(fields.max.value);
                        slider.noUiSlider.set([
                            Math.max(rangeMin, Math.min(minValue, maxValue)),
                            Math.min(rangeMax, Math.max(minValue, maxValue)),
                        ]);
                    });
                }
            }

            return wrapper;
        }

        function createCurrentFacet(id, value, label) {
            const wrapper = createElement('current-facet-button');
            const button = createElement(
                'button',
                'btn btn--with-icon size--tiny',
                `${label} ×`
            );
            button.type = 'button';
            button.dataset.facetId = id;
            button.dataset.facetValue = value;
            wrapper.append(button);
            return wrapper;
        }

        function renderCurrentFacets(facets) {
            if (!currentFacets) return;
            const buttons = [];

            for (const facet of facets) {
                if (facet.type === 'RANGE') {
                    if (
                        facet.minSelected == null &&
                        facet.maxSelected == null
                    ) {
                        continue;
                    }

                    const rangeLabel = [
                        facet.minSelected ?? facet.min,
                        facet.maxSelected ?? facet.max,
                    ]
                        .filter((value) => value !== undefined && value !== null && value !== '')
                        .join(' – ');

                    buttons.push(createCurrentFacet(
                        facet.id,
                        '',
                        `${facet.label}: ${rangeLabel}`
                    ));
                    continue;
                }

                for (const value of facetValues(facet)) {
                    if (!value.selected) continue;
                    buttons.push(
                        createCurrentFacet(
                            facet.id,
                            value.id,
                            `${facet.label}: ${value.label}`
                        )
                    );
                }
            }

            currentFacets.replaceChildren(...buttons);
        }

        function renderFacets(facets) {
            if (!facetContainer) return;

            const openFacetIds = new Set(
                [...facetContainer.querySelectorAll('details[data-voyado-facet-group][open]')]
                    .map((details) => details.dataset.voyadoFacetGroup)
            );
            const groups = facets.map((facet) => {
                const details = createElement('details', 'filter-group');
                details.dataset.voyadoFacetGroup = facet.id;
                details.open = openFacetIds.has(facet.id);
                const summary = createElement('summary');
                const content = createElement('div', 'content pt-12 pb-24');
                summary.append(createElement('span', '', facet.label));
                content.append(
                    facet.type === 'RANGE'
                        ? createRangeFacet(facet)
                        : createValueFacet(facet)
                );
                details.append(summary, content);
                return details;
            });

            facetContainer.replaceChildren(...groups);
            renderCurrentFacets(facets);
        }

        function renderSort(sortOrder) {
            if (!sort || !Array.isArray(sortOrder?.options)) return;

            sort.replaceChildren(
                ...sortOrder.options.map((item) => {
                    const option = createElement('option', '', item.label);
                    option.value = item.id ?? '';
                    option.selected = item.id === sortOrder.selected;
                    return option;
                })
            );
        }

        function applyFilters(event) {
            event?.preventDefault();
            options.onFiltersChange(selectedFiltersFromForm());
        }

        sort?.addEventListener('change', (event) => {
            options.onSortChange(event.target.value);
        }, true);
        facetForm?.addEventListener('change', applyFilters);
        facetForm?.addEventListener('submit', applyFilters);
        clearFilters?.addEventListener('click', (event) => {
            event.preventDefault();
            options.onClearFilters();
        });
        currentFacets?.addEventListener('click', (event) => {
            const button = event.target.closest('[data-facet-id]');
            if (!button) return;

            const filters = cloneFilters(options.getFilters());
            const id = button.dataset.facetId;
            const value = button.dataset.facetValue;

            if (!value) {
                delete filters[id];
            } else {
                filters[id] = (filters[id] || []).filter((item) => item !== value);
                if (filters[id].length === 0) delete filters[id];
            }

            options.onFiltersChange(filters);
        });

        return Object.freeze({
            render(primaryList, fallbackSort) {
                renderFacets(
                    Array.isArray(primaryList?.facets) ? primaryList.facets : []
                );
                renderSort(primaryList?.sort || fallbackSort);
            },
        });
    }

    window.VOYADO_LIST_CONTROLS = Object.freeze({ create });
})(window, document);
